import React from "react";
import "./SectionThirteen.css";
import Card from "./components/Card";
import Slider from "./components/Slider";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import fetchSectionThirteen from "./packages/fetchSectionThirteen";
import { setOrganizer } from "../../../../../state/HomePage/SectionThirteen/SectionThirteenAction";
import fetchSectionThirteenTwo from "./packages/fetchSectionThirteenTwo";
import { setMedia } from "../../../../../state/HomePage/SectionThirteenTwo/SectionThirteenTwoAction";
import { useState } from "react";
import SubmitForm from "../../../../Admin/AdminHomePage/components/EditableSectionThirteen/packages/submitForm";
import Popup from "reactjs-popup";
import SubmitMedia from "../../../../Admin/AdminHomePage/components/EditableSectionThirteen/packages/submitMedia";
import DeleteIcon from '@mui/icons-material/Delete';
import WarningPopUp from "../../../../../components/WarningPopUp/WarningPopUp";
import DeleteCorganizer from "./packages/DeleteCorganizer";
import updatePicURL from "../../../../../packages/updatePicUrl";

const SectionThirteen = ({ editable = false }) => {
  const [btnLoading, setBtnLoading] = useState(false);
  const dispatch = useDispatch();
  const organizerData = useSelector((state) => state.sectionThirteen);
  const mediaData = useSelector((state) => state.sectionThirteenTwo);

  useEffect(() => {
    fetchSectionThirteen({
      setOrganizer,
      dispatch: dispatch,
    });

    fetchSectionThirteenTwo({
      setMedia,
      dispatch,
    });
  }, []);

  function refreshPage() {
    window.location.reload();
  }

  const handleDelete = async ({ id }) => {
    let success = await DeleteCorganizer({
      btnLoading: btnLoading,
      setBtnLoading: setBtnLoading,
      id: id
    });
    if (success) {
      refreshPage();
    }
  };

  const EditButton = ({ nameItem, link, roleItem, id, isActionCreate, title }) => {
    const [name, setName] = useState("");
    const [companyLink, setCompanyLink] = useState("");
    const [role, setRole] = useState("");
    const [file, setFile] = useState(null);

    const [btnLoading, setBtnLoading] = useState(false);

    useEffect(() => {
      setName(nameItem);
      setCompanyLink(link);
      setRole(roleItem);
    }, []);

    function refreshPage() {
      window.location.reload();
    }
    const submitOrganizer = async (e) => {
      e.preventDefault();
      // console.log(file);
      if (isActionCreate) {
        let success = await SubmitForm({
          isActionCreate,
          name,
          role,
          companyLink,
          file,
          id,
          btnLoading,
          setBtnLoading: setBtnLoading,
        });
        if (success) {
          refreshPage();
        }
      } else {
        let success = await SubmitForm({
          name,
          role,
          companyLink,
          file,
          id,
          btnLoading,
          setBtnLoading: setBtnLoading,
        });
        if (success) {
          refreshPage();
        }
      }
    };

    return (
      <Popup
        trigger={
          <div
            className="edit_btn "
          >
            {title ?? "Edit"}
          </div>
        }
        modal
      >
        {(close) => {
          return (
            <div className="ehp_edit_popup">
              <div className="edit_model">
                <div className="edit_model_top">
                  <h1 className="edit_model_top_header">
                    {title ?? "Edit Organizer Card"}
                  </h1>
                </div>
                <div className="edit_model_main">
                  <div className="edit_model_items">
                    <label htmlFor="name" className="edit_model_items_label">
                      Name:
                    </label>
                    <input
                      type="text "
                      id="name"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                    />
                  </div>
                  <div className="edit_model_items">
                    <label
                      htmlFor="companyLink"
                      className="edit_model_items_label"
                    >
                      Company Link:
                    </label>
                    <input
                      type="text"
                      id="companyLink"
                      value={companyLink}
                      onChange={(e) => {
                        setCompanyLink(e.target.value);
                      }}
                    />
                  </div>
                  {!isActionCreate && <div className="edit_model_items">
                    <label htmlFor="role" className="edit_model_items_label">
                      Role:
                    </label>
                    <input
                      type="text"
                      id="role"
                      value={role}
                      onChange={(e) => {
                        setRole(e.target.value);
                      }}
                    />
                  </div>}

                  <div className="edit_model_items">
                    <label htmlFor="image" className="edit_model_items_label">
                      Image File: <span style={{ color: "red" }} >
                        {isActionCreate && "Required"}
                      </span>
                    </label>
                    <input
                      type="file"
                      id="image"
                      name="file"
                      accept=".png, .jpg, .jpeg, .svg"
                      onChange={(e) => {
                        setFile(e.target.files[0]);
                      }}
                    />
                  </div>

                  <div className="edit_model_button">
                    <button onClick={submitOrganizer}>
                      {btnLoading ? "Loading..." : "submit"}
                    </button>
                    <button
                      className="edit_model_button_close"
                      onClick={() => {
                        close();
                      }}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          );
        }}
      </Popup>
    );
  };

  const AddMedia = () => {
    const [scale, setScale] = useState(1);
    const [companyLink, setCompanyLink] = useState("");
    const [file, setFile] = useState(null);

    const [btnLoading, setBtnLoading] = useState(false);

    function refreshPage() {
      window.location.reload();
    }
    const submitMedia = async (e) => {
      e.preventDefault();
      let success = await SubmitMedia({
        companyLink,
        file,
        btnLoading,
        setBtnLoading: setBtnLoading,
      });
      if (success) {
        refreshPage();
      }
    };

    return (
      <Popup
        trigger={
          <div
            className="add_media"
            style={{
              transform: `scale(${scale})`,
              transition: "transform 0.3s ease",
            }}
          >
            Add Media
          </div>
        }
        modal
      >
        {(close) => {
          return (
            <div className="ehp_edit_popup">
              <div className="edit_model">
                <div className="edit_model_top">
                  <h1 className="edit_model_top_header">Add Media</h1>
                </div>
                <div className="edit_model_main">
                  <div className="edit_model_items">
                    <label
                      htmlFor="companyLink"
                      className="edit_model_items_label"
                    >
                      Comapany Link
                    </label>
                    <input
                      type="text "
                      id="companyLink"
                      value={companyLink}
                      onChange={(e) => {
                        setCompanyLink(e.target.value);
                      }}
                    />
                  </div>

                  <div className="edit_model_items">
                    <label htmlFor="image" className="edit_model_items_label">
                      Image File:
                    </label>
                    <input
                      type="file"
                      id="image"
                      name="file"
                      accept=".png, .jpg, .jpeg, .svg"
                      onChange={(e) => {
                        setFile(e.target.files[0]);
                      }}
                    />
                  </div>

                  <div className="edit_model_button">
                    <button onClick={submitMedia}>
                      {btnLoading ? "Loading..." : "submit"}
                    </button>
                    <button
                      className="edit_model_button_close"
                      onClick={() => {
                        close();
                      }}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          );
        }}
      </Popup>
    );
  };

  return (
    <div className="sectionThirteen">
      <div className="sectionThirteen_top">
        {
          organizerData?.organizer
            .map((o, index) => {
              return <div key={index}
                className="sectionThriteen_top_item">
                <div style={{
                  display: "flex",
                  justifyContent: "space-between"
                }} >
                  {editable && (
                    <EditButton
                      nameItem={o?.name}
                      roleItem={o?.role}
                      link={o?.companyLink}
                      id={o?._id}
                    />
                  )}
                  {
                    (editable && o?.role === "Co-organizer") ?
                      <div style={{ cursor: "pointer" }} >
                        <WarningPopUp trigger={<DeleteIcon />}
                          handelSubmit={() => { handleDelete({ id: o?._id ?? "" }); }}
                          isBtnLoading={btnLoading}
                          popUpTitle={"Are you Sure You Want to delete?"} />
                      </div> :
                      ""
                  }
                </div>
                <Card
                  imgUrl={
                    updatePicURL({
                      inputURL: o?.imageLink ??
                        ""
                    })
                  }
                  title={o?.role ?? "Co-organizer"}
                />
              </div>
            })
        }
      </div>

      <div style={{
        margin: "3rem 0"
      }} >
        {editable && (
          <EditButton
            title={"Add New Co-organizer"}
            isActionCreate={true}
            nameItem={""}
            roleItem={""}
            link={""}
            id={""}
          />
        )}
      </div>

      <div className="sectionThirteen_bottom">
        <div className="sectionThirteen_bottom_top">
          <span className="sectionThirteen_bottom_top_header">
            Media coverages of Global
          </span>
          <span className="sectionThirteen_bottom_top_header">
            Entrepreneurship <span className="p_color">Bootcamp</span>
          </span>
        </div>

        <div className="sectionThirteen_bottom_body">
          {editable && <AddMedia />}
          <Slider data={mediaData?.media} editable={editable} />
        </div>
      </div>
    </div>
  );
};
export default SectionThirteen;
